import { Text, Container, Grid, Button, Space } from "@mantine/core";
import { useState } from "react";
import InstructionModal from "../Components/Tasks-Components/InstructionModal";
import AddTaskModal from "../Components/Tasks-Components/AddTaskModal";
import AccordionExample from "../Components/Tasks-Components/Accordion";

export const Tasks = () => {
  const [isOpen, setOpen] = useState(false);
  const [isOpen1, setOpen1] = useState(false);
  const type = localStorage.getItem("type");
  return (
    <>
      <Container align="left" style={{ padding: 0, width: "100%" }}>
        <Grid>
          <Text
            weight={700}
            size="xl"
            style={{
              fontSize: 28,
              borderBottom: "3px solid #1C7ED6",
              marginBottom: "20px",
              marginTop: "30px",
            }}
          >
            GENERAL INSTRUCTIONS
          </Text>
        </Grid>
        <Space h="lg" />
        <Text>
          Please go through the basic instructions carefully to understand the
          inductions procedure
          <Space h="lg" />
          <Button
            style={{ cursor: "pointer" }}
            onClick={() => {
              setOpen(true);
            }}
            compact
            variant="outline"
          >
            Click
          </Button>
        </Text>

        <Container style={{ width: "100%", padding: 0, margin: 0 }}>
          <Grid style={{ justifyContent: "space-between" }}>
            <Text
              weight={700}
              size="xl"
              style={{
                borderBottom: "3px solid #1C7ED6",
                marginTop: "50px",
                marginBottom: "70px",
                fontSize: "20px",
              }}
            >
              TASKS
            </Text>
            {type == "ADMIN" && (
              <Button
                style={{ marginTop: "45px", marginBottom: "70px" }}
                onClick={() => {
                  setOpen1(true);
                }}
              >
                Add Task
              </Button>
            )}
          </Grid>

          <Container
            style={{
              boxShadow: "0px 0px 2px 0px #000",
              borderRadius: "5px",
              width: "100%",
              overflow: "hidden",
              padding: 0,
              margin: 0,
            }}
          >
            <Container style={{ backgroundColor: "transparent" }}>
              <AccordionExample />
            </Container>
          </Container>
        </Container>
      </Container>
      <InstructionModal open={isOpen} setOpen={setOpen} />
      <AddTaskModal open={isOpen1} setOpen={setOpen1} />
    </>
  );
};
